<script>
export default {
    name: 'RoleForm',

    data () {

        return {
            role: {
                id: 0,
                active: true
            }
        };
    },

    methods: {

        saveRole () {

            this.$root.loading = true;
            this.$http.post(`Admin/ManageRoles`, this.role).then(response => {
                this.role = { id: 0, active: true };
                this.$root.loading = false;
                window.Swal.fire({type: 'success', title: response.data });
                this.$emit('refreshData');
            }).catch(() => { this.$root.loading = false; });
        }
    }
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="md:w-1/4 w-1/2 p-tiny">
            <label for="grid-name" class="label-control">Role:</label>
            <input type="text" v-model="role.role1" id="grid-name" class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <label for="grid-description" class="label-control">Description:</label>
            <textarea v-model="role.description" id="grid-description" class="input-control text-xs" cols="3" rows="1"></textarea>
        </div>
        <div class="md:w-1/12 w-1/2 p-tiny mt-4">
            <label for="grid-status" class="label-control">Active
                <input type="checkbox" v-model="role.active" id="grid-status"></label>
        </div>
        <div class="md:w-1/12 w-1/2 p-tiny mt-4">
            <button class="btn-sm btn-primary text-xs rounded" @click.prevent="saveRole">
                <i class="fa fa-plus"></i> Role</button>
        </div>
    </div>
</template>
